import { memo } from 'react';

const LoadingPlaceholder = memo(({ height = '12rem' }: { height?: string }) => (
  <div
    className="tw-w-full tw-bg-gray-100 tw-animate-pulse"
    style={{ height }}
  ></div>
));

LoadingPlaceholder.displayName = 'LoadingPlaceholder';

export default LoadingPlaceholder;
